<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <span><strong>Profissinal:</strong></span>
                <p>{{ data.form.lotacao.profissional.nome }}</p>
            </rkm-col>

            <rkm-col>
                <span><strong>CBO:</strong></span>
                <p>{{ data.form.lotacao.ocupacao.codigo }} - {{ data.form.lotacao.ocupacao.nome }}</p>
            </rkm-col>

            <rkm-col>
                <span><strong>Paciente:</strong></span>
                <p>{{ data.form.paciente.nome }}</p>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Desfecho do atendimento"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                @change="handleDesfechoChange"
                                v-model="data.model.finalizacao.desfechoId"
                            >
                                <rkm-form-radio :value="enums.desfecho.PACIENTE_LIBERADO">Paciente Liberado</rkm-form-radio>
                                <rkm-form-radio :value="enums.desfecho.EVASAO">Evasão</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.finalizacao.desfechoId == enums.desfecho.EVASAO">
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.evasao.motivo"
                    label="Motivo da evasão"
                    v-model="data.model.finalizacao.evasao.motivo"
                />
            </rkm-col>
        </rkm-row>

        <modal-impressao ref="ModalImpressao" />

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaFaaProps"
        />
    </rkm-form>
</template>

<script>
// Components.
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'

// Mixins.
import { error, object, prontoAtendimentoAssinaturaEletronica, repository, stringCase, unmask } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalImpressao },
    computed: {
        validations() {
            return {
                evasao: {
                    motivo: { required: true, min: 1, max: 200 },
                },
            }
        },
    },
    created() {
        this.repositories = {
            atendimentoTriagem: this.getConectaSusRepository('prontoAtendimento.atendimentoTriagem'),
        }
    },
    data: () => ({
        enums: { desfecho },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleDesfechoChange() {
            this.resetDesfecho()
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    if (this.data.additionals.isEnfermeiro && this.data.model.classificacaoRiscoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar a classificação de risco.'
                        })
                    }
                    else if (this.data.model.finalizacao.desfechoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Desfecho é obrigatório.'
                        })
                    }
                    else {
                        this.setLoading()

                        let request = {
                            dorToracica: this.data.model.dorToracica,
                            plantaoId: this.plantaoId,
                            alergias: this.data.model.alergias.map(item => {
                                return {
                                    alergiaId: item.alergia.id,
                                    criticidadeId: item.alergia.criticidade.id,
                                    reacoesObservacoes: item.alergia.reacoesObservacoes,
                                }
                            }),
                            medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => {
                                return {
                                    medicamentoId: item.medicamento.id,
                                }
                            }),
                            atendimentoId: this.data.model.atendimentoId,
                            centroCustoIdPara: this.data.model.centroCustoIdPara,
                            classificacaoRiscoId: this.data.model.classificacaoRiscoId,
                            filaId: this.data.model.filaId,
                            prioridadeId: (this.data.form.fila
                                && this.data.form.fila.prioridade
                                && this.data.form.fila.prioridade.id) || null,
                            gestacao: {
                                dum: this.data.model.gestacao.dum ? moment(this.data.model.gestacao.dum).format('YYYY-MM-DD') : null,
                                gestante: this.data.model.gestacao.gestante,
                            },
                            fatoresRisco: this.data.model.fatoresRisco,
                            fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                            historicoEnfermagem: this.data.model.historicoEnfermagem,
                            medicamentosUso: this.data.model.medicamentosUso,
                            observacoes: this.data.model.observacoes,
                            outrasAvaliacoesCondicoes: this.data.model.outrasAvaliacoesCondicoes,
                            sinaisVitais: this.data.model.sinaisVitais.map(item => {
                                return {
                                    cintura: item.cintura || null,
                                    glicemia: item.glicemia || null,
                                    intensidadeDor: item.intensidadeDor || null,
                                    pa: item.pa || null,
                                    paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                                    pulso: item.pulso || null,
                                    respiracao: item.respiracao || null,
                                    saturacao: item.saturacao || null,
                                    temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                                }
                            }),
                            escalaComaGlasgow: this.data.model.escalasComaGlasgow.map(item => {
                                return {
                                    aberturaOcularId: item.aberturaOcular.id,
                                    respostaVerbalId: item.respostaVerbal.id,
                                    respostaMotoraId: item.respostaMotora.id,
                                    reatividadePupilarId : item.reatividadePupilar.id,
                                    observacao: item.observacoes
                                }
                            }),
                            encaminhamentos: this.data.model.encaminhamentos.map(item => {
                                return {
                                    infraestruturaId: item.infraestruturaId,
                                    urgente: item.urgente,
                                    motivo: item.motivo,
                                    observacoes: item.observacoes,
                                }
                            }),
                        }

                        if (this.data.model.avaliacaoAntropometrica.massa || this.data.model.avaliacaoAntropometrica.altura) {
                            request.avaliacaoAntropometrica = {
                                altura: this.data.model.avaliacaoAntropometrica.altura,
                                alturaTipoMedidaId: this.data.model.avaliacaoAntropometrica.alturaTipoMedidaId,
                                alturaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                                massa: this.data.model.avaliacaoAntropometrica.massa,
                                massaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                            }
                        }

                        if (this.data.model.finalizacao.desfechoId) {
                            request.finalizacao = {
                                desfecho_id: this.data.model.finalizacao.desfechoId,
                            }

                            if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.EVASAO) {
                                request.finalizacao = Object.assign(request.finalizacao , {
                                    evasao: {
                                        motivo: this.data.model.finalizacao.evasao.motivo,
                                    }
                                })
                            }
                        }

                        const formData = this.objectToFormData(this.camelObjectKeysToSnakeRecursive(request))

                        this.repositories.atendimentoTriagem.store(formData)
                            .then(({ data }) => {
                                const finish = () => {
                                    this.$refs.ModalImpressao.open(
                                        data.impressoes,
                                        data.atendimentoId,
                                        () => this.$emit('save')
                                    )
                                }

                                if (data.assinar) {
                                    this.afterSign = faaAssinada => {
                                        return this.repositories.atendimentoTriagem.storeFaaAssinada(data.id, {
                                            faa_assinada: faaAssinada
                                        })
                                    }

                                    this.onSign = () => finish()
                                    this.onSkipSign = () => finish()

                                    this.askToSignAtendimento(
                                        async () => this.signFaa(
                                            data.atendimentoId,
                                            [{ tipo: 'triagem', id: data.id }],
                                            `faa-${data.faaId}-atendimento-triagem-${data.id}`
                                        ),
                                        async () => finish()
                                    )
                                }
                                else {
                                    this.showSaveNotification()
                                    finish()
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        resetDesfecho() {
            this.data.model.finalizacao = Object.assign(this.data.model.finalizacao, {
                evasao: {
                    motivo: null,
                }
            })
        },
    },
    mounted() {
        this.resetDesfecho()
    },
    mixins: [error, object, prontoAtendimentoAssinaturaEletronica, repository, stringCase, unmask],
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
}
</script>